// src/components/PrivacyPolicy.js
import React from 'react';
import { Container, Typography, Box, Link } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h3" gutterBottom component="h1">
        Informativa sulla Privacy
      </Typography>

      <Typography variant="body1" paragraph>
        La presente informativa descrive come "QuantoSpendo" ("noi", "nostro") raccoglie, utilizza e protegge le informazioni degli utenti.  La tua privacy è importante per noi, e ci impegniamo a proteggere i tuoi dati personali.
      </Typography>

      <Typography variant="h5" gutterBottom component="h2">
        Quali Dati Raccogliamo e Perché
      </Typography>

      <Typography variant="h6" gutterBottom component="h3">
        1. Dati di Registrazione
      </Typography>
      <Typography variant="body1" paragraph>
        Quando ti registri a QuantoSpendo, raccogliamo il tuo indirizzo email.  Questo è necessario per:
        <ul>
          <li>Creare e gestire il tuo account.</li>
          <li>Permetterti di accedere all'applicazione.</li>
          <li>Comunicare con te in caso di problemi con il tuo account o per fornirti assistenza.</li>
          <li>Inviarti notifiche relative al servizio (ad esempio, modifiche ai termini di servizio).</li>
          </ul>
          Non utilizzeremo il tuo indirizzo email per scopi di marketing senza il tuo esplicito consenso.
      </Typography>

      <Typography variant="h6" gutterBottom component="h3">
        2. Dati di Utilizzo (Firebase Analytics)
      </Typography>
      <Typography variant="body1" paragraph>
        Utilizziamo Firebase Analytics, un servizio di analisi web fornito da Google, per raccogliere informazioni sull'utilizzo dell'applicazione.  Questi dati ci aiutano a capire come gli utenti interagiscono con QuantoSpendo, quali funzionalità sono più utilizzate e come possiamo migliorare l'esperienza utente.
        <br /><br />
        I dati raccolti da Firebase Analytics includono:
        <ul>
          <li>Informazioni sul dispositivo (tipo di dispositivo, sistema operativo, identificatori univoci del dispositivo).</li>
          <li>Informazioni sull'utilizzo dell'app (pagine visitate, funzionalità utilizzate, tempo trascorso sull'app).</li>
          <li>Dati di eventi (azioni specifiche eseguite nell'app, come l'aggiunta di una spesa o la creazione di una famiglia).</li>
          <li>Indirizzo IP (anonimizzato).  Google Analytics anonimizza l'indirizzo IP prima di memorizzarlo, il che significa che non viene memorizzato il tuo indirizzo IP completo.</li>
        </ul>
        Questi dati sono raccolti in forma *aggregata e anonima*.  Non sono collegati al tuo indirizzo email o ad altre informazioni personali identificabili. Non possiamo identificarti personalmente tramite i dati di Firebase Analytics.
        <br/><br/>
         Puoi trovare maggiori informazioni sulla privacy di Firebase Analytics qui: <Link href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">https://firebase.google.com/support/privacy</Link>
          e sulla privacy di Google in generale:  <Link href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</Link>

      </Typography>

      <Typography variant="h6" gutterBottom component="h3">
        3. Cookie
      </Typography>
        <Typography variant="body1" paragraph>Utilizziamo cookie tecnici strettamente necessari per le seguenti finalità
          <ul>
            <li>
            Mantenere la tua sessione attiva mentre utilizzi l'applicazione.
            </li>
            <li>
            Gestire le tue preferenze relative ai cookie (consenso).
            </li>
          </ul>
        Questi cookie sono essenziali per il funzionamento di QuantoSpendo e non possono essere disattivati.  Non utilizziamo cookie di profilazione o di terze parti per scopi pubblicitari.
        </Typography>

      <Typography variant="h5" gutterBottom component="h2">
        Hosting
      </Typography>
      <Typography variant="body1" paragraph>
        La nostra applicazione è ospitata su Render. Render potrebbe raccogliere alcuni dati tecnici (come l'indirizzo IP) per garantire la sicurezza e il corretto funzionamento del servizio.  Questi dati sono gestiti in conformità con la privacy policy di Render. Puoi trovare maggiori informazioni qui:<Link href="https://render.com/privacy" target="_blank" rel="noopener noreferrer">https://render.com/privacy</Link>

      </Typography>

      <Typography variant="h5" gutterBottom component="h2">
        Con Chi Condividiamo i Tuoi Dati
      </Typography>
      <Typography variant="body1" paragraph>
        Non vendiamo, affittiamo o condividiamo i tuoi dati personali con terze parti per scopi di marketing.  Condividiamo i tuoi dati solo con:
        <ul>
          <li>**Google (Firebase Analytics):** Come descritto sopra, per l'analisi dell'utilizzo dell'app.</li>
          <li>**Render:** Per l'hosting dell'applicazione.</li>
        </ul>
        Questi fornitori di servizi sono tenuti a proteggere i tuoi dati in conformità con le leggi applicabili e con le nostre istruzioni.
      </Typography>

      <Typography variant="h5" gutterBottom component="h2">
        I Tuoi Diritti
      </Typography>
      <Typography variant="body1" paragraph>
        In conformità con il Regolamento Generale sulla Protezione dei Dati (GDPR) e altre leggi applicabili, hai i seguenti diritti:
         <ul>
            <li>
              <b>Diritto di accesso:</b> Hai il diritto di sapere quali dati personali trattiamo e di ottenerne una copia.
            </li>
            <li>
              <b>Diritto di rettifica:</b> Hai il diritto di chiedere la correzione di dati personali inesatti o incompleti.
            </li>
            <li>
              <b>Diritto alla cancellazione ("diritto all'oblio"):</b> Hai il diritto di chiedere la cancellazione dei tuoi dati personali in determinate circostanze.
            </li>
            <li>
                <b>Diritto di limitazione di trattamento</b>: puoi chiederci di limitare l'elaborazione dei tuoi dati
            </li>
            <li>
              <b>Diritto di opposizione:</b> Hai il diritto di opporti al trattamento dei tuoi dati personali per finalità di marketing diretto o per altri motivi legittimi.
            </li>
         </ul>

      </Typography>

      <Typography variant="h5" gutterBottom component="h2">
        Modifiche a Questa Informativa
      </Typography>
      <Typography variant="body1" paragraph>
        Ci riserviamo il diritto di aggiornare questa informativa sulla privacy in qualsiasi momento.  Eventuali modifiche saranno pubblicate su questa pagina, e, se le modifiche sono significative, ti informeremo tramite email (se ci hai fornito il tuo consenso per le comunicazioni).
      </Typography>

      <Typography variant="h5" gutterBottom component="h2">
        Contatti
      </Typography>
      <Typography variant="body2">
        Per qualsiasi domanda o richiesta relativa a questa informativa sulla privacy, o per esercitare i tuoi diritti, puoi contattarci all'indirizzo email: <Link href="mailto:info@quantospendo.com">info@quantospendo.com</Link>.
      </Typography>
    </Container>
  );
};

export default PrivacyPolicy;